(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Christmas-Newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('christmas-newsletter')) {
    customElements.define('christmas-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.fitHeadings = () => {
          this.querySelectorAll('[data-cn-fit]').forEach((line) => {
            line.style.removeProperty('font-size');
            line.style.whiteSpace = 'nowrap';
            const size = parseFloat(getComputedStyle(line).fontSize);
            const width = line.clientWidth;
            if (width > 0 && line.scrollWidth > width) {
              const fitted = size * width / line.scrollWidth;
              if (fitted >= 20) line.style.fontSize = fitted + 'px';
              else line.style.whiteSpace = 'normal';
            }
          });
        };
        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.fitHeadings);
        });
        this.observer.observe(this.querySelector('.cn__content'));
        document.fonts?.ready.then(() => { if (this.isConnected) this.fitHeadings(); });
        this.fitHeadings();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shf-delivery-options"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-shfdo-section]').forEach((root) => {
      if (root.dataset.shfdoReady) return;
      root.dataset.shfdoReady = 'true';
      const form = root.querySelector('[data-shfdo-form]');
      const button = form.querySelector('button[type=submit]');
      const status = root.querySelector('[data-shfdo-status]');
      const success = root.querySelector('[data-shfdo-success]');
      const phone = form.elements.phone_number;
      const contactPhone = root.dataset.contactPhone.trim();
      const submitLabel = button.textContent.trim();
      const withPhone = (text) => (text || 'Please call {phone} for assistance.').replace(/\{phone\}/g, () => contactPhone);
      const message = (text, error = false) => {status.textContent = text; status.dataset.error = String(error);};
      phone.addEventListener('input', () => phone.setCustomValidity(''));
      let pending = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending) return;
        const digits = phone.value.replace(/\D/g, '');
        phone.setCustomValidity(digits.length >= 7 && digits.length <= 15 ? '' : (form.dataset.invalidPhone || 'Please enter a valid phone number.'));
        if (!form.reportValidity()) return;
        if (form.elements.website.value) return;
        let endpoint;
        try {
          endpoint = new URL(form.dataset.endpoint);
          if (endpoint.protocol !== 'https:' || endpoint.hostname !== 'script.google.com' || !/^\/macros\/s\/[a-zA-Z0-9_-]+\/exec$/.test(endpoint.pathname) || endpoint.search || endpoint.hash) throw new Error('endpoint');
        } catch (_) {
          message(withPhone(form.dataset.setupError), true);
          return;
        }
        const payload = new URLSearchParams({
          full_name: form.elements.full_name.value.trim(),
          phone_number: phone.value.trim(),
          delivery_address: form.elements.delivery_address.value.trim(),
          consent: 'yes',
          website: '',
          submitted_at: new Date().toISOString(),
          source: 'showhome-delivery-request',
          request_id: crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`
        });
        if (payload.get('full_name').length < 2 || payload.get('delivery_address').length < 8) {message(form.dataset.incompleteText || 'Please complete your name and delivery address.', true); return;}
        pending = true;
        button.disabled = true;
        button.textContent = form.dataset.sendingLabel || 'Sending your request…';
        message('');
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 45000);
        try {
          const response = await fetch(endpoint.href, {method: 'POST', body: payload, credentials: 'omit', redirect: 'follow', referrerPolicy: 'no-referrer', signal: controller.signal});
          if (!response.ok) throw new Error('response');
          const receipt = await response.json();
          if (receipt.status !== 'success' || receipt.request_id !== payload.get('request_id')) throw new Error('receipt');
          form.hidden = true;
          success.hidden = false;
          success.focus();
          form.reset();
        } catch (_) {
          message(withPhone(form.dataset.submitError), true);
        } finally {
          window.clearTimeout(timeout);
          pending = false;
          button.disabled = false;
          button.textContent = submitLabel;
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shf-landing-body"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (root) => {
      if (root.dataset.shfFaqReady === 'true') return;
      root.dataset.shfFaqReady = 'true';
      const items = Array.from(root.querySelectorAll('[data-shf-faq-item]'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
      const input = root.querySelector('[data-shf-faq-search]');
      const empty = root.querySelector('[data-shf-faq-empty]');
      if (!input) return;
      input.addEventListener('keydown', (event) => {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.select();
        }
      });
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;
        items.forEach((item) => {
          const matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        if (empty) empty.hidden = visibleCount !== 0;
      });
    };
    const initializeAllFaqs = (scope) => {
      scope.querySelectorAll('[data-shf-faq]').forEach(initializeFaq);
    };
    initializeAllFaqs(document);
    document.addEventListener('shopify:section:load', (event) => initializeAllFaqs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shf-landing-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (root) => {
      if (root.dataset.shfFaqReady === 'true') return;
      root.dataset.shfFaqReady = 'true';

      const items = Array.from(root.querySelectorAll('[data-shf-faq-item]'));

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });

      const input = root.querySelector('[data-shf-faq-search]');
      const empty = root.querySelector('[data-shf-faq-empty]');
      if (!input) return;

      input.addEventListener('keydown', (event) => {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.select();
        }
      });

      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount !== 0;
      });
    };

    const initializeAllFaqs = (scope) => {
      scope.querySelectorAll('[data-shf-faq]').forEach(initializeFaq);
    };

    initializeAllFaqs(document);
    document.addEventListener('shopify:section:load', (event) => initializeAllFaqs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shf-hero-video')) {
    customElements.define('shf-hero-video', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.poster = this.querySelector('.deferred-media__poster');
        this.poster?.addEventListener('click', () => this.startPlayback(true), { signal: this.events.signal });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              this.startPlayback(false);
            }
          });
          this.observer.observe(this);
        } else {
          this.startPlayback(false);
        }
      }

      startPlayback(fromClick) {
        if (!this.video) {
          const source = this.querySelector('template')?.content.querySelector('video');
          if (!source) return;
          this.video = source.cloneNode(true);
          this.video.defaultMuted = true;
          this.video.muted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.video.controls = true;
          this.video.addEventListener('playing', () => {
            if (this.poster) this.poster.hidden = true;
          }, { signal: this.events.signal });
          this.video.addEventListener('error', () => {
            if (this.poster) this.poster.hidden = true;
          }, { signal: this.events.signal });
          this.appendChild(this.video);
        }

        if (fromClick) this.observer?.disconnect();
        const video = this.video;
        const showFallback = () => {
          if (!this.isConnected || this.video !== video || !video.paused) return;
          video.controls = true;
          if (this.poster) this.poster.hidden = fromClick || Boolean(video.error);
        };

        try {
          // Keep play() inside the click handler so Safari retains user activation.
          const playback = video.play();
          playback?.catch(showFallback);
        } catch (error) {
          showFallback();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.events = null;
        if (this.video) {
          this.video.pause();
          this.video.remove();
          this.video = null;
        }
        if (this.poster) this.poster.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
